import { Text } from 'react-native'
import { convertLineHeight, styled } from '~/utils'

export const Description = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      isDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    },
  }
})
